module.exports = __webpack_public_path__ + "img/dot-interro.3cf866cd.svg";